/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown>, since: NonNullable<unknown> }} Motor_Current_Detection_IncidentInputs */



/**
* | since | output |
* | --- | --- |
* | "false" | "Motor fault (current detection)" |
* | "true" | "Motor fault (current detection) since {date}" |
* | * | "Motor fault (current detection)" |
*
* @param {Motor_Current_Detection_IncidentInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const motor_current_detection_incident = /** @type {((inputs: Motor_Current_Detection_IncidentInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Motor_Current_Detection_IncidentInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") {
		if (i?.since === "false") return /** @type {LocalizedString} */ (`Motor fault (current detection)`);
		if (i?.since === "true") return /** @type {LocalizedString} */ (`Motor fault (current detection) since ${i?.date}`);
		return /** @type {LocalizedString} */ (`Motor fault (current detection)`)
	}
	{
		if (i?.since === "false") return /** @type {LocalizedString} */ (`Incident moteur (détection de courant)`);
		if (i?.since === "true") return /** @type {LocalizedString} */ (`Incident moteur (détection de courant) depuis le ${i?.date}`);
		return /** @type {LocalizedString} */ (`Incident moteur (détection de courant)`)
	}
});